import { Fragment, useState, useEffect } from "react";
import { Dialog, Transition } from "@headlessui/react";
import Button from "../../../button";
import CreditModify from "./CreditModify";
import { usePaymentCreationMutation } from "../../../../store/paymentCreation";
import PlanSuccessModal from "./PlanSuccessModal";

const ModifyModal = ({
  isOpen,
  handleClose,
  handleSuccess,
  professionalInfoDetail,
}) => {
  const [selectedPaymentPlan, setSelectedPaymentPlan] = useState();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [
    paymentCreation,
    {
      isLoading: paymentCreationLoader,
      isSuccess: paymentCreationSuccess,
      isError: paymentCreationError,
    },
  ] = usePaymentCreationMutation();

  useEffect(() => {
    if (paymentCreationSuccess && !paymentCreationLoader) {
      setShowSuccessModal(true);
      handleSuccess();
      // setIsSuccessOpen(true);
    }
  }, [paymentCreationSuccess]);

  const handleModifyPlan = () => {
    const params = {
      payment_option_id: selectedPaymentPlan.id,
    };
    paymentCreation(params);
  };

  return (
    <>
      <Transition.Root show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-50" onClose={handleClose}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>
          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-[10px] bg-white px-0 md:px-[20px] pb-6 md:pb-10 pt-6 md:pt-8 text-left shadow-xl transition-all sm:my-8 w-full max-w-[710px]">
                  <CreditModify
                    setSelectedPaymentPlan={setSelectedPaymentPlan}
                    professionalInfoDetail={professionalInfoDetail}
                    handleClose={handleClose}
                  />
                  <div className="flex items-center justify-between gap-5 mt-[30px] px-[20px] w-full flex-col-reverse md:flex-row">
                    <Button
                      title="Cancel"
                      type="button"
                      classes="bg-[#EBEFF3] w-full max-w-[full] md:max-w-[160px] py-3 md:py-4 flex justify-center items-center text-sm md:text-base uppercase font-black leading-[160%] rounded-md  text-[#485868] duration-500"
                      onClick={handleClose}
                    />
                    <Button
                      title="Modify Plan"
                      type="button"
                      classes={`bg-primary ${
                        paymentCreationLoader
                          ? "w-full max-w-[full] md:max-w-[200px]"
                          : "w-full max-w-[full] md:max-w-[160px]"
                      } py-3 md:py-4 flex justify-center items-center text-sm md:text-base uppercase font-black leading-[160%] rounded-md text-white duration-500`}
                      onClick={handleModifyPlan}
                      buttonLoader={paymentCreationLoader}
                    />
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
      <PlanSuccessModal
        isSuccessOpen={showSuccessModal}
        handleClose={() => {
          setShowSuccessModal(false);
          handleClose();
        }}
      />
    </>
  );
};

export default ModifyModal;
